export const TYPE_JOURNALIER = 'Journalier';
export const TYPE_PERIODIQUE = 'Périodique';
export const TYPE_ANNUEL = 'Annuel';

export const CATEGORIE_EDITIONS_FUSIONNEES = 'arrete_periodique_editions_fusionnees';
export const CATEGORIE_RECAPITULATIF_MR_JR = 'recapitulatif_mr_jr';
export const CATEGORIE_RECAPITULATIF_PAR_RECU = 'recapitulatif_par_recu';
